import React from 'react'

import Hero from './sections/Hero'
import Highlights from './sections/Highlights'
import Projects from './sections/Projects'
import Community from './sections/Community'
import Features from './sections/Features'
import ComingSoon from './sections/ComingSoon'
import JoinCallout from './sections/JoinCallout'
import Companies from './sections/Companies'
import { Props } from './data'
import ROUTE from './route'

import Main from 'src/components/Main'
import Page from 'src/components/Page'
import HelpCenter from 'src/components/sections/HelpCenterArticles'
import SEO from 'src/components/SEO'
import { PageConfig } from 'src/routing/types'

const MembershipProduct: PageConfig<Props> = ({ faqs }) => (
  <Page>
    <SEO
      title="SuperHi Unlimited Membership"
      description="Unlimited access to online coding courses for beginners and beyond. Learn new skills in our graphic design courses and project management courses too."
      imageUrl="https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/share.png"
      imageFm="png8"
    />

    <Main>
      <Hero />

      <Highlights />

      <Projects />

      <Features />

      <JoinCallout />

      <ComingSoon />

      <Community
        title="The value of community"
        subtitle="We love connecting with our students&thinsp;&mdash;&thinsp;and the feeling seems to be mutual! We’re upping our game with events (free to members), mentorship, and more."
      />

      <Companies />

      {faqs && (
        <HelpCenter
          {...faqs}
          title="Questions?"
          footerButtonText="View more FAQs"
          collapseTopPadding
        />
      )}
    </Main>
  </Page>
)

MembershipProduct.route = ROUTE

export { getStaticProps } from './data'
export default MembershipProduct
